import type { ReactNode } from 'react';

interface CardProps { children: ReactNode; className?: string; onClick?: () => void; style?: React.CSSProperties }

export default function Card({ children, className = '', onClick, style }: CardProps) {
  return <div className={`card ${className}`} onClick={onClick} style={{ ...(onClick ? { cursor: 'pointer' } : {}), ...style }}>{children}</div>;
}

Card.Header = function CardHeader({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`card-h ${className}`}>{children}</div>;
};

Card.Body = function CardBody({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={className} style={{ padding: className.includes('py-') ? undefined : undefined }}>{children}</div>;
};

Card.Footer = function CardFooter({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`card-footer ${className}`}>{children}</div>;
};
